import qs from 'query-string';

import routes, {
  INITIAL_URL_IGNORELIST,
} from 'common/constants/routing.constants';
import history from 'customHistory';
import { stores } from '../../stores';

class MetaService {
  fetchAccountsAndProfile = async () => {
    const getAccountData = await stores.AccountsStore.fetchAccounts();
    const getProfileData = await stores.ProfileStore.fetchProfileData();
    return Promise.all([getAccountData, getProfileData]);
  };

  postAuthRedirect = () => {
    const { initialUrl } = stores.AppStore;
    const { initialQueryParams } = stores.AuthStore;
    let redirectTo = initialUrl;
    console.log('initialUrl', initialUrl, initialQueryParams);

    if (INITIAL_URL_IGNORELIST.includes(initialUrl)) redirectTo = '/';

    if (!stores.AccountsStore.hasInvestorAccount) {
      const { startedFromWizard } = stores.ProfileStore.metaData;
      if (
        startedFromWizard &&
        window.location.pathname !== routes.wizard.path
      ) {
        redirectTo = routes.wizard.path;
      }
    }

    history.push(`${redirectTo}?${qs.stringify(initialQueryParams)}`);
  };
}

export const metaService = new MetaService();
